

























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Const } from "@/const";
import Header from "@/commonComponents/header/header.vue";
import RightController from "./rightController/rightController.vue";
import TableView from "./tableView/tableView.vue";
import PagePreview from "./pagePreview/pagePreview.vue";
import FileOpen from '@/commonComponents/fileOpen/fileOpen.vue';
import SelectOpenStorageModal from "@/commonComponents/alertModal/selectOpenStorageModal/selectOpenStorageModal.vue";
import DisplayController from './displayController/displayController.vue';
import Tutorial from "../tutorial/tutorial.vue";
import License from "../top2/mainContents/license/license.vue";
import LoadingScreen from "@/commonComponents/loadingScreen/loadingScreen.vue"
import FontConvertModal from "@/commonComponents/alertModal/fontConvertModal/fontConvertModal.vue";
import DiscardConfirmation from "@/commonComponents/alertModal/discardConfirmationModal/discardConfirmationModal.vue";
import SelectExcelSheetModal from "@/commonComponents/alertModal/selectExcelSheetModal/selectExcelSheetModal.vue";

import { Document } from '@/model/document2/document';
import { InsertionData } from '@/model/document2/insertionData/insertionData';
import { Page } from '@/model/document2/page/page';
import { Surface } from '@/model/document2/page/surface/surface';
import { Design } from '@/model/document2/page/surface/design/design';
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { InsertionCombination } from '@/insertionCombination/insertionCombination';

import { UuidHelper } from '@/helper/uuidHelper';
import { InsertionHelper } from '@/helper/insertionHelper';
import { FileHelper } from '@/helper/fileHelper';
import { PlainTextLayer } from '@/model/document2/page/surface/design/layer/plainTextLayer';
import { DebugHelper } from "@/helper/debugHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { FontHelper } from "@/helper/fontHelper";
import { NativeHelper } from "@/helper/nativeHelper";
import { StringHelper } from "@/helper/stringHelper";
import { ExcelHelper } from "@/helper/excelHelper";
import { LogHelper } from "@/helper/logHelper";
import AskConvert3dTextAlertModal from "@/commonComponents/alertModal/askConvert3dTextAlertModal/askConvert3dTextAlertModal.vue";

import { FileConverter } from '@/label_convert/fileConverter';

import { CloudAccount } from "@/cloudAccount/cloudAccount";

import { Rectangle } from '@/utilityModels/rectangle';
import { Vector2 } from '@/utilityModels/vector2';

import { FontManager } from '@/model/fontManager/fontManager';
import { DateHelper } from '../../helper/dateHelper';
import { DocumentHelper } from "@/helper/documentHelper";

@Component({
  components: {
    Header,
    RightController,
    TableView,
    PagePreview,
    FileOpen,
    SelectOpenStorageModal,
    DisplayController,
    Tutorial,
    License,
    LoadingScreen,
    FontConvertModal,
    DiscardConfirmation,
    SelectExcelSheetModal,
    AskConvert3dTextAlertModal
  }
})
export default class InsertionEditor extends Vue
{
    // アニメーション関連の設定
    private static readonly ANIMATION_DURATION = 0.5;   // アニメーション長さ(s)
    private static readonly ANIMATION_FPS = 24.0;         // アニメーションフレームレート(fps)

    private get currentTab() { return "/InsertionEditor"; }

    isTutorial = false;
    isLicense = false;
    isReverse = false;

    private insertionPageList : Array<Page> = [];

    // フォントロードフラグ
    private isFontLoaded = false;

    // 印刷枚数編集中か
    private isInputPrintCount : boolean = false;

    private selectOpenStorageModalShown : boolean = false;

    // 差し込みラインを選択状態にかかわらず強制表示するフラグ
    private isInsetionPathVisibleForcibly : boolean = false;
    // 差し込みライン描画用
    // 全てのレイヤーのDOM外接矩形
    private layerRects : { [ id : string ] : Rectangle } = {};
    // カラムのDOM頂点座標
    private columnPoints : Array<Vector2> = [];
    // 触れているレイヤー
    private touchedLayer : Layer | null = null;
    private onTouchLayer(layer : Layer | null)
    {
        this.touchedLayer = layer;
    }

    // 全てのレイヤーのDOM外接矩形を更新
    private updateLayerRects()
    {
        var page = this.currentDocument.pageList[0];
        var surface = page.getSurface(this.currentDocument.isReverseSurface);
        var design = surface.getDesign(0);
        var orgLayers = design != null ? design.getAllLayers(false) : []; 

        var pagePreview = this.$refs.pagePreview as PagePreview;
        var rects : { [ id : string ] : Rectangle } = {};
        for(var i = 0; i < orgLayers.length; ++i)
        {
            // 追加する
            rects[orgLayers[i].id] = pagePreview.getLayerBoundingDOMRect(orgLayers[i]);
        }
        this.layerRects = rects;
    }

    // カラムの頂点座標を更新する
    private updateColumnPoints()
    {
        var tableView = this.$refs.tableView as TableView;
        var colArray = this.currentDocument.insertionData.columnDataArray;
        var points : Array<Vector2> = [];
        for(var i = 0; i < colArray.length; ++i)
        {
            // 追加
            var point = tableView.getInsertionArrowPosition(i);
            points.push(point);
        }
        this.columnPoints = points;
    }

    // 差し込み線を表示するか
    private get isInsertionPathVisible() { return this.isInsetionPathVisibleForcibly || this.currentDocument.selectedInsertionWholeColumn >= 0; }

    // 差し込みのパス情報取得
    private get pathInfoArray()
    {
        var array : Array<{
            path : string,
            isColumnSelected : boolean,
            isTargetInsertion : boolean,
            isTouched : boolean,
            layerId : string,
            deleteButtonPosition : Vector2
        }> = [];

        var colArray = this.currentDocument.insertionData.columnDataArray;
        if(this.columnPoints.length != colArray.length) return array;
        var page = this.currentDocument.pageList[0];
        var surface = page.getSurface(this.currentDocument.isReverseSurface);
        var design = surface.getDesign(0);
        if(design == null) return array;
        for(var i = 0; i < colArray.length; ++i)
        {
            // カラムの頂点座標
            var columnPoint = this.columnPoints[i];
            // カラムの差し込み先になるレイヤーを調べる
            var colData = colArray[i];
            var insertionId = colData.insertionId;
            var allLayers = design.getAllLayers(false);
            for(var layerIdx = 0; layerIdx < allLayers.length; layerIdx++)
            {
                var layer = allLayers[layerIdx];
                // 1) 差し込み対象である
                var isTargetInsertion = insertionId != "" && layer.insertionId == insertionId && this.layerRects[layer.id] != null;
                // 2) レイヤーを触れていて、かつカレントのカラムである
                var isTouched = this.touchedLayer == layer && i == this.currentDocument.selectedInsertionWholeColumn;
                if(isTargetInsertion || isTouched)
                {
                    // レイヤーの外接矩形
                    var rect = this.layerRects[layer.id];
                    // レイヤーのX座標中点より、カラムの頂点座標が左ならレイヤーの左中央、それ以外なら右中央がレイヤーを示す座標
                    var layerPointX = columnPoint.x < rect.x + rect.width / 2 ? rect.x : rect.x + rect.width;
                    var layerPointY = rect.y + rect.height / 2;
                    var layerPoint = new Vector2(layerPointX, layerPointY);
                    // 曲線のためのコントロールポイントは、カラムの頂点座標が左なら画面左端、それ以外なら画面右端
                    var controlPointX = columnPoint.x < rect.x + rect.width / 2 ? 0 : window.innerWidth - 280;
                    var controlPointY = (columnPoint.y + layerPoint.y) / 2;
                    var controlPoint = new Vector2(controlPointX, controlPointY);
                    // カラムの頂点〜レイヤーまでのベジェ曲線のパスを求める
                    var path = "M "
                        + columnPoint.x
                        + ","
                        + columnPoint.y
                        + " Q "
                        + controlPoint.x
                        + ","
                        + controlPoint.y
                        + " "
                        + layerPoint.x
                        + ","
                        + layerPoint.y;

                    array.push({
                        path : path,
                        isColumnSelected : i == this.currentDocument.selectedInsertionWholeColumn,
                        isTargetInsertion : isTargetInsertion,
                        isTouched : isTouched,
                        layerId : layer.id,
                        deleteButtonPosition: layerPoint
                    });
                }
            }
        }

        DebugHelper.trace(array);

        return array;
    }

    private getDeleteButtonStyle(position : Vector2)
    {
        return {
            position : 'absolute',
            left : (position.x - 12) + 'px',
            top : (position.y - 12) + 'px',
            width : '24px',
            height : '24px'
        }
    }

    // アニメーション
    // アニメーション中のレイヤーId
    private animationLayerId = "";
    // アニメーション解除のタイムアウト
    private endAnimationTimeout = -1;
    // アニメーションするサークル
    private animationCircle;
    // アニメーションする線の長さ設定
    private animationPathOffset = 0;
    private animationPathLength = 0;
    // 追加アニメーション
    private startInsertionAnimation(layerId : string)
    {
        var svg = document.getElementById('insertionSvg');
        if(svg == null) return

        // 今存在しているアニメーションをクリアする
        this.clearInsertionAnimation();

        // path
        var path = "";
        for(var i = 0; i < this.pathInfoArray.length; ++i)
        {
            if(this.pathInfoArray[i].layerId == layerId)
            {
                path = this.pathInfoArray[i].path;
                break;
            }
        }
        // アニメーションフラグ
        this.animationLayerId = layerId;

        var circle = document.createElementNS(svg.namespaceURI, 'circle');
        circle.setAttribute('cx', '0px');
        circle.setAttribute('cy', '0px');
        circle.setAttribute('r', '8px');
        circle.setAttribute('fill', this.userConfigColor);

        var animation = document.createElementNS(svg.namespaceURI, 'animateMotion');
        animation.setAttribute('path', path);
        animation.setAttribute('dur', InsertionEditor.ANIMATION_DURATION + 's');
        animation.setAttribute('calcMode', 'linear');
        animation.setAttribute("begin", "indefinite");
        circle.appendChild(animation);

        svg.appendChild(circle);
        this.animationCircle = circle;
        // アニメーション開始
        if(animation['beginElement']) animation['beginElement']();
        // パスのアニメーション開始
        this.startPathAnimation();

        // アニメーション解除
        this.endAnimationTimeout = setTimeout(() =>{
            this.clearInsertionAnimation();
        }, (InsertionEditor.ANIMATION_DURATION * 1000) + 100);
    }

    // パスについてのアニメーション開始
    private startPathAnimation()
    {
        // パスの長さを取得する
        var path = document.getElementById('insertion_animation' + this.animationLayerId);
        if(path == null) return;
        var pathLength = path['getTotalLength'] ? path['getTotalLength']() : 1000;
        // パスの長さを適用する
        this.animationPathLength = pathLength;
        this.animationPathOffset = pathLength;
        // アニメーションスタート
        this.pathAnimationCore(this.animationLayerId);
    }

    // パスについてのアニメーション処理
    private pathAnimationCore(layerId : string, frameCount : number = 0)
    {
        // フレームカウントが終了に満たない場合は次のアニメーションを実行する
        var isContinue = this.animationLayerId == layerId && frameCount < InsertionEditor.ANIMATION_DURATION * InsertionEditor.ANIMATION_FPS;
        if(isContinue)
        {
            setTimeout(() => this.pathAnimationCore(layerId, frameCount + 1), 1000 / InsertionEditor.ANIMATION_FPS);
        }
        // パスをずらす
        this.animationPathOffset = this.animationPathLength - this.animationPathLength * frameCount / (InsertionEditor.ANIMATION_DURATION * InsertionEditor.ANIMATION_FPS);
    }

    // アニメーションのクリア
    private clearInsertionAnimation()
    {
        var svg = document.getElementById('insertionSvg');
        if(svg == null) return;

        // 今存在しているアニメーションをクリアする
        if(this.endAnimationTimeout >= 0) 
        { 
            clearTimeout(this.endAnimationTimeout);
            this.animationLayerId = "";
            if(this.animationCircle != null && svg.contains(this.animationCircle))
            {
                svg.removeChild(this.animationCircle);
            }
        }
    }

    // 待機
    private isWaiting = false;
    private get waitingTitle() { return "処理中"; }
    private get waitingMessage() { return "処理をしています…"; }

    // ヘッダーで画面から抜ける時の処理
    private onHeaderNavigationStart(link : string)
    {
        if(link == "/LayoutEditor" || link == "/PrintSetting")
        {
            // レイアウト、印刷に遷移する時に処理中表示
            this.isWaiting = true;
        }
    }

    private onHeaderNavigationFinish(link : string)
    {
        // 処理中を非表示
        this.isWaiting = false;
    }

    public get currentDocument() : Document
    {
      	return this.$store.getters.document;
    }

    private get isReverseSurface()
    {
        var document = this.currentDocument;
        return document.isReverseSurface;
    }

    public get currentInsertionCombination() : InsertionCombination
    {
        return this.$store.getters.insertionCombination;
    }

    private get isDebugMode(){
        return DebugHelper.isDebugMode;
    }

    mounted(){
        window.addEventListener("scroll", this.scrollEvent);
        window.addEventListener("resize", this.resizeEvent);

        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else if(CookieHelper.getItem("insertionEditorTutorial") != true){
            this.isTutorial = true;
        }

        // ブラウザの戻る・進むを使用した時のために位置リセット
        this.currentDocument.selectedInsertionRow = 0;
        this.currentDocument.selectedInsertionColumn = 0;
        this.currentDocument.selectedInsertionWholeColumn = -1;

        this.applyInsertionToFirstDesign();
        this.updateDesign();

        // TODO 多分もういらないけど残しておく
        // Webfontロード
        FontHelper.loadWebFonts(() =>
        {
            // ロード完了
            this.isFontLoaded = true;
        }, () =>
        {
            // ロード失敗
            this.isFontLoaded = true;
        });

        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);

        this.$nextTick(() =>
        {
            // レイヤー位置情報更新
            this.updateLayerRects();
            // カラム位置情報更新
            this.updateColumnPoints();
        });

        // 差し込みライン強制表示
        this.isInsetionPathVisibleForcibly = true;
    }

    private onTableScrolled()
    {
        // カラム位置情報更新
        this.updateColumnPoints();
    }

    private onTableColumnClicked()
    {
        // カラムクリック時、差し込みラインの強制表示を止める
        this.isInsetionPathVisibleForcibly = false;
    }

    private destroyed()
    {
        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");

        window.removeEventListener("scroll", this.scrollEvent);
        window.removeEventListener("resize", this.resizeEvent);

        this.disposeDesign();
    }

    private scrollEvent(){
        // レイヤー位置情報更新
        this.updateLayerRects();
        // カラム位置情報更新
        this.updateColumnPoints();
    }

    private resizeEvent(){
        // レイヤー位置情報更新
        this.updateLayerRects();
        // カラム位置情報更新
        this.updateColumnPoints();
    }

    // コマンド処理
    // DL版で呼び出す
    private processExecCommand(paramParent : any)
    {
        try
        {
            var command : string = paramParent.command;
            var parameter : any = paramParent.parameter;

            if(command == "save_document_completed")
            {
                // ドキュメントの保存完了をネイティブから通知される
                // if(this.isSaveModalVisible)
                // {
                //     // 保存モーダル表示中であれば、完了処理を行う
                //     this.saveModalCompletion();
                // }
                // ドキュメントのハッシュ更新
                this.currentDocument.updateHash();

                // 保存履歴送信
                LogHelper.sendLog("1000", {
                    productId : this.currentDocument.productId,
                    code : this.currentDocument.paperCode,
                    templateId : this.$store.getters.data.selectedTemplate.id,
                    cloud : 0
                });
            }
            else if(command == "import_document")
            {
                // ドキュメント読み込み
                var doc = FileHelper.loadDocumentAnyway(parameter.document);
                if(doc != null)
                {
                    let filePath = parameter.filePath;
                    let fileName = parameter.fileName != null ? parameter.fileName : "";

                    doc.currentFilePath = filePath;
                    doc.openedFileName = fileName;
                    var comp = () =>
                    {
                        // ドキュメントの準備
                        this.$store.getters.applicationState.preloadDocument = doc;
                        // 画面遷移
                        this.$router.push("/LayoutEditor");
                    };
                    // フォントコンバート対応
                    FontManager.applyUnloadedFontsToDocument(doc);
                    if(doc.unloadedFonts.length > 0)
                    {
                        // 利用できないフォントがあった場合
                        var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                        // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                        fontConvertModal.open(doc.unloadedFonts,
                        () =>
                        {
                            comp();
                        });
                    }
                    else
                    {
                        comp();
                    }
                }
            }
            else if(command == "import_label9_document")
            {
                // ラベル9ドキュメント読み込み
                let documentBuf = parameter.document;
                let filePath = parameter.filePath;

                // zip解凍
                let Unzip = require('zlibjs/bin/unzip.min').Zlib.Unzip;
                let uz = new Unzip(documentBuf);
                let filenames = uz.getFilenames();
                if(filenames && filenames.length > 0)
                {
                    // 最初のファイル(xml)
                    let decompressed = uz.decompress(filenames[0]);
                    let documentXml = StringHelper.utf8ArrayToStr(decompressed);
                    // ファイルコンバート
                    let fileConverter = new FileConverter(this.$store.getters.fontManager);
                    let doc = fileConverter.deserializeLabel9FromXml(documentXml);
                    if(doc != null)
                    {
                        doc.currentFilePath = filePath;

                        // 完了処理
                        let completion = () =>
                        {
                            if(doc == null) return;
                            let completion2 = () =>
                            {
                                if(doc == null) return;
                                // ドキュメントの準備
                                this.$store.getters.applicationState.preloadDocument = doc;
                                // 画面遷移
                                this.$router.push("/LayoutEditor");
                            }
                            // ラベル屋さん9の3D文字のコンバート対応
                            if(DocumentHelper.contains3dTextLayers(doc)) {
                                (this.$refs.askConvert3dTextAlertModal as AskConvert3dTextAlertModal).open(ret => {
                                    if(doc == null) return;
                                    if(ret) {
                                        DocumentHelper.convert3dTextLayersToSimpleTextLayers(doc);
                                    }
                                    completion2();
                                })
                            } else {
                                completion2();
                            }
                        };

                        if(doc.unloadedFonts.length > 0)
                        {
                            // 利用できないフォントがあった場合
                            var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                            // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                            fontConvertModal.open(doc.unloadedFonts,
                            () =>
                            {
                                if(doc != null) { completion(); }
                            });
                        }
                        else
                        {
                            completion();
                        }
                    }
                }
            }
            else if(command == "open_paper_info")
            {
                // 用紙情報を開く
                NativeHelper.sendNativeEvent("open_external_link", { url : Const.PRODUCT_DETAIL_URL_BASE + this.currentDocument.productCode });
            }
            else if(command == "import_insertion_data")
            {
                // 差し込みデータ読み込み
                if(parameter.type == "xlsx")
                {
                    // xlsx読み込み
                    let buf = parameter.data as ArrayBuffer;
                    ExcelHelper.xlsxBinaryToJsonStringWithSelectSheet(buf, (sheetNames : string[], callback : (index : number) => void) =>
                    {
                        var modal = this.$refs.selectExcelSheetModal as SelectExcelSheetModal;
                        modal.open(sheetNames, (button : string, index : number) =>
                        {
                            if(button == "ok")
                            {
                                callback(index);
                            }
                        });
                    }, (result) =>
                    {
                        this.onFileRead(result, "", "binary");
                    }, () =>
                    {
                        DebugHelper.trace("import excel error");
                    });
                }
                else if(parameter.type == "csv")
                {
                    // csv読み込み
                    let buf = parameter.data as ArrayBuffer;
                    let csv = ExcelHelper.csvBinaryToString(buf);
                    this.onFileRead(csv, "", "text");
                }
            }
            else if(command == "save_to_cloud_document")
            {
                // クラウドへ保存
                this.$store.dispatch("setCloudOperation", this.$router.currentRoute.path);
                this.$store.dispatch("setCloudMode", "save");
                var cloudAccount = this.$store.getters.cloudAccount as CloudAccount;
                if(cloudAccount.isSignIn)
                {
                    this.$router.push("/cloud");
                }
                else
                {
                    this.$store.dispatch("setSignInToGo", "cloud");
                    this.$router.push("/signIn");
                }
            }
            else if(command == "notify_local_image_path")
            {
                // 画像のローカルパスを通知された
                var localImageFilePath = parameter.filePath;
                DebugHelper.trace(localImageFilePath);
                if(!localImageFilePath.startsWith("file://"))
                {
                    // ローカルパススキーム追加
                    localImageFilePath = "file://" + localImageFilePath;
                }
                // セルテキスト変更
                this.changeCellText(localImageFilePath, this.currentDocument.selectedInsertionRow, this.currentDocument.selectedInsertionColumn);
            }
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
    }

    private design : Design | null = null;
    private updateDesign()
    {
        this.design = null;
        this.design = InsertionHelper.createInsertedDesign(this.currentDocument, this.currentDocument.selectedInsertionRow, this.currentDocument.isReverseSurface);
    }
    private disposeDesign()
    {
        this.design = null;
    }

    // コマンドのコール
    private onDoCommand(command: string, parameter: any)
    {
        if(command == "goNext")
        {
            // レイアウトへ
            this.goLayout();
        }
        else if (command == "editDesign")
        {
            // デザイン編集
            this.editDesign();
        }
        else if(command == "changeCellText")
        {
            // セルのテキスト変更
            this.changeCellText(parameter.text, parameter.row, parameter.column);
        }
        else if(command == "changePrintCount")
        {
            // 印刷枚数変更
            this.changePrintCount(parameter.value, parameter.row);
            // 編集終了
            this.isInputPrintCount = false;
        }
        else if(command == "selectLayer")
        {
            // レイヤーを選択
            this.setInsertion(parameter.layer, this.currentDocument.selectedInsertionColumn);
        }
        else if(command == "importFile")
        {
            // ファイル読み込み
            this.importFile();
        }
        else if(command == "exportFile")
        {
            // ファイル書き出し
            this.exportFile();
        }
        else if(command == "changeColumnDataProperty")
        {
            // 列データ変更
            this.changeColumnDataProperty(parameter.value, parameter.propertyName);
        }
        else if(command == "insertRow")
        {
            // 行追加
            this.insertRow(parameter.direction);
        }
        else if(command == "insertColumn")
        {
            // 列追加
            this.insertColumn(parameter.direction);
        }
        else if(command == "deleteRow")
        {
            // 行削除
            this.deleteRow();
        }
        else if(command == "selectRow")
        {
            // 行選択
            this.selectRow(parameter.row);
        }
        else if(command == "deleteColumn")
        {
            // 列削除
            this.deleteColumn();
        }
        else if(command == "startInputPrintCount")
        {
            // 編集開始
            this.isInputPrintCount = true;
        }
        else if(command == "setFirstRowAsColumnName")
        {
            // 1行目を列名にする
            this.setFirstRowAsColumnName(parameter.enable);
        }
        else if(command == "changePrint")
        {
            // 印刷切り替え
            this.changePrint(parameter.isPrint, parameter.row);
        }
        else if(command == "orderRow")
        {
            // 行並び替え
            this.orderRow(parameter.isAscending);
        }
        else if(command == "changeSurface")
        {
            // 面裏変更
            this.changeSurface(parameter.isReverse);
        }
        else if(command == "importLocalImagePath")
        {
            // ローカル画像のインポート
            if(UserAgentHelper.isElectron())
            {
                // フルパスを読み込むのはネイティブで行う
                DebugHelper.trace("request_import_local_image_path")
                NativeHelper.sendNativeEvent("request_import_local_image_path", {});
            }
            else
            {
                DebugHelper.trace("request_import_local_image_path cannot be called on web.")
            }
        }
    }

    // レイアウトへ
    private goLayout()
    {
        // デザインエディターに遷移
        this.goLint("/LayoutEditor", true);
    }

    // 遷移処理
    // showWait : 待機モーダルを表示する
    private goLint(link : string, showWait : boolean = false)
    {
        if(showWait)
        {
            this.isWaiting = true;
            setTimeout(() =>
            {
                this.isWaiting = false;
                this.$router.push(link);
            }, 50);
        }
        else
        {
            this.$router.push(link);
        }
    }

    // DesignEditorに遷移する
    private editDesign()
    {
        // 差し込みの時は常に0番目のページ、デザインを編集する
        this.currentDocument.currentPageIndex = 0;
        this.$router.push("/DesignEditor")
    }

    // セルのテキスト変更
    private changeCellText(text : string, row : number, column : number)
    {
        this.currentDocument.insertionData.setCellData(0, text, row, column);

        this.applyInsertionToFirstDesign();
        // デザイン更新
        this.updateDesign();
    }


    // 印刷枚数変更
    private changePrintCount(value : number, row : number)
    {
        DebugHelper.trace(value)
        DebugHelper.trace(row)
        this.currentDocument.insertionData.getRowData(row).printCount = value;

        this.applyInsertionToFirstDesign();
    }

    // レイヤーに対して差し込みをセットする
    private setInsertion(layer : Layer, column : number)
    {
        if(this.currentDocument.selectedInsertionWholeColumn >= 0)
        {
            // 差し込みセットメイン処理
            this.setInsertionCore(layer, column);
            // アニメーションスタート
            this.startInsertionAnimation(layer.id);     
        }
    }

    private setInsertionCore(layer : Layer, column : number)
    {
        DebugHelper.trace(layer.insertionId);
        var columnData = this.currentDocument.insertionData.getColumnData(column);
        // 差し込みidを作成
        var insertionId = columnData.insertionId == "" ? UuidHelper.getUuid() : columnData.insertionId;
        columnData.insertionId = insertionId;
        layer.insertionId = insertionId;
        this.applyInsertionToFirstDesign();
        // デザイン更新
        this.updateDesign();
    }

    // レイヤーの差し込み削除
    private deleteInsertionById(layerId : string)
    {
        DebugHelper.trace("delete")
        var page = this.currentDocument.pageList[0];
        var surface = page.getSurface(this.currentDocument.isReverseSurface);
        var design = surface.getDesign(0);
        if(design == null) return;
        var allLayers = design.getAllLayers(false);
        for(var i = 0; i < allLayers.length; ++i)
        {
            if(allLayers[i].id == layerId)
            {
                // 追加アニメーションクリア
                this.clearInsertionAnimation();
                // 削除処理
                this.deleteInsertion(allLayers[i]);
                break;
            }
        }
    }
    private deleteInsertion(layer : Layer)
    {
        DebugHelper.trace(layer)
        layer.insertionId = "";
        this.applyInsertionToFirstDesign();
        // デザイン更新
        this.updateDesign();
    }

    // 差し込みIdを元に、position == 0のデザインからオリジナルレイヤーを取得する
    private getOriginalsLayerFromInsertionId(insertionId : string)
    {
        var array : Array<Layer> = new Array();
        if(insertionId != "")
        {
            var firstPage = this.currentDocument.pageList[0];
            var surfaceCount = firstPage.hasReverse ? 2 : 1;
            for(var surfaceIndex = 0; surfaceIndex < surfaceCount; ++surfaceIndex)
            {
                var surface = firstPage.getSurface(surfaceIndex == 1);
                var design = surface.getDesign(0);
                if(design != null)
                {
                    var allLayers = design.getAllLayers(false);
                    for(var i = 0; i < allLayers.length; ++i)
                    {
                        var layer = allLayers[i];
                        if(layer.insertionId == insertionId)
                        {
                            array.push(layer);
                        }
                    }
                }
            }
        }

        return array;
    }

    private importFile()
    {
        // if(this.isDebugMode){
            this.selectOpenStorageModalShown = true;
        // }else{
        //     this.importDocument();
        // }
    }

    private exportFile()
    {
        // ファイル書き出し
        if(UserAgentHelper.isElectron())
        {
            // DL版はネイティブで保存する
            NativeHelper.sendNativeEvent("request_export_insertion_data", {});
            return;
        }

        var csv = this.currentDocument.insertionData.getCsv();
        var dateString = DateHelper.getString(DateHelper.getDateToday());
        var filename = Const.CSV_FILE_NAME.replace("{DATE}", dateString);
        FileHelper.saveCsv(csv, filename);
    }

    private loadInsertionFile(text: string, fileType : string, readType : string) {
        return new Promise(resolve => {
            setTimeout(() => {
                if(readType == "binary")
                {
                    // xlsx読み込み
                    var loadedData = InsertionData.createFromXlsx(text, this.currentDocument.insertionData);
                    this.currentDocument.insertionData = loadedData;
                }
                else
                {
                    // csv読み込み
                    var loadedData = InsertionData.createFromCsv(text, this.currentDocument.insertionData);
                    this.currentDocument.insertionData = loadedData;
                }

                if(this.currentDocument.insertionData.isFirstRowAsColumnName && this.currentDocument.insertionData.getRowDataCount() <= 1)
                {
                    // 1行目を列名にするが有効で、行数が1の場合は行がなくなってしまうので、1行目を列名にするをオフにする
                    this.currentDocument.insertionData.isFirstRowAsColumnName = false;
                }

                // カレントを 0,0 に戻す
                this.currentDocument.selectedInsertionRow = 0;
                this.currentDocument.selectedInsertionColumn = 0;
                this.currentDocument.selectedInsertionWholeColumn = -1;

                // 開始行と終了行をリセットする
                this.resetRowRange();

                this.applyInsertionToFirstDesign();
                this.updateDesign();
                this.$nextTick(() =>
                {
                    this.updateLayerRects();
                    this.updateColumnPoints();
                });

                resolve();
            }, 0);
        });
    }

    // ファイルが選択されたら表を読み込む
    private onFileRead(text : string, fileType : string, readType : string)
    {
        this.isWaiting = true;
        this.$nextTick(() => {
            // 描画が止まってしまうので描画されてから始める
            this.loadInsertionFile(text, fileType, readType).then(() => {
                this.isWaiting = false;
            });
        });
    }

    // 列プロパティ変更
    private changeColumnDataProperty(value : any, propertyName : string)
    {
        var columnData = this.currentDocument.insertionData.getColumnData(this.currentDocument.selectedInsertionColumn);
        if(columnData[propertyName] != null)
        {
            columnData[propertyName] = value;

            this.applyInsertionToFirstDesign();
            // デザイン更新
            this.updateDesign();
        }
    }

    // 行追加
    private insertRow(direction : string)
    {
        var targetRow = this.currentDocument.selectedInsertionRow;
        if(direction == "down") { targetRow++; }

        if(targetRow >= this.currentDocument.insertionData.getRowDataCount())
        {
            // 追加
            this.currentDocument.insertionData.addRowData();
        }
        else
        {
            // 挿入
            this.currentDocument.insertionData.insertRowData(targetRow);
        }

        // 開始行と終了行をリセットする
        this.resetRowRange();
        // 追加した行にカレントを移動
        // this.currentDocument.selectedInsertionRow = targetRow;
        
        // デザイン更新
        this.updateDesign();
    }

    // 列追加
    private insertColumn(direction : string)
    {
        var targetColumn = this.currentDocument.selectedInsertionColumn;
        if(direction == "right") { targetColumn++; }

        if(targetColumn >= this.currentDocument.insertionData.getColumnDataCount())
        {
            // 追加
            this.currentDocument.insertionData.addColumnData();
        }
        else
        {
            // 挿入
            this.currentDocument.insertionData.insertColumnData(targetColumn);
        }

        // 記憶した差し込み箇所更新
        for(var pattern in this.currentInsertionCombination.insertionCombination){
            if(this.currentInsertionCombination.insertionCombination[pattern] == null){ continue; }
            if(this.currentInsertionCombination.insertionCombination[pattern] == -1){ continue; }
            if(this.currentInsertionCombination.insertionCombination[pattern] >= targetColumn){
                this.currentInsertionCombination.insertionCombination[pattern]++;
            }
        }

        // 追加した列にカレントを移動
        this.currentDocument.selectedInsertionColumn = targetColumn;

        // カラムの座標更新
        this.$nextTick(() =>
        {
            this.updateColumnPoints();
        });
    }

    // 行削除
    private deleteRow()
    {
        // 行数が1の場合削除しない
        // 1行目を列名にするが有効の場合は行数が2の場合も削除しない
        var min = this.currentDocument.insertionData.isFirstRowAsColumnName ? 2 : 1;
        if(this.currentDocument.insertionData.getRowDataCount() <= min) { return; }

        var targetRow = this.currentDocument.selectedInsertionRow;
        this.currentDocument.insertionData.removeRowData(targetRow);
        // カレントを変更
        var startRow = this.currentDocument.insertionData.isFirstRowAsColumnName ? 1 : 0;
        if(this.currentDocument.selectedInsertionRow > startRow) { this.currentDocument.selectedInsertionRow -= 1; }

        // 一番上の行を消した場合はデザインを更新
        if(min - 1 == targetRow)
        {
            this.applyInsertionToFirstDesign();
        }

        // 開始行と終了行をリセットする
        this.resetRowRange();

        // デザイン更新
        this.updateDesign();
    }

    // 行選択
    private selectRow(row : number)
    {
        this.currentDocument.selectedInsertionRow = row;
        // デザイン更新
        this.updateDesign();
    }

    // 列削除
    private deleteColumn()
    {
        // 列数が1の場合削除しない
        if(this.currentDocument.insertionData.getColumnDataCount() <= 1) { return; }

        var targetColumn = this.currentDocument.selectedInsertionColumn;
        this.currentDocument.insertionData.removeColumnData(targetColumn);

        // カレントを変更
        if(this.currentDocument.selectedInsertionColumn > 0) { this.currentDocument.selectedInsertionColumn -= 1; }
        this.$nextTick(() =>
        {
            this.updateColumnPoints();
        });
    }

    // 1行目を列名にする
    private setFirstRowAsColumnName(enable : boolean)
    {
        var isAddRow = false;
        if(enable && this.currentDocument.insertionData.getRowDataCount() < 2)
        {
            // もし1行しかなかった場合は、そのまま1行目を列名にすると行がなくなってしまうので、行追加をする
            this.currentDocument.insertionData.addRowData();

            isAddRow = true;
        }

        this.currentDocument.insertionData.isFirstRowAsColumnName = enable;

        if(enable && this.currentDocument.selectedInsertionRow <= 0)
        {
            // 1行目を列名にするがONになるときに、カレントの行が0だとカレントが見えなくなるので1にする
            this.currentDocument.selectedInsertionRow = 1;
        }

        this.applyInsertionToFirstDesign();

        // 開始行と終了行をリセットする
        this.resetRowRange();

        // デザイン更新
        this.updateDesign();
    }

    // 印刷切り替え
    private changePrint(isPrint : boolean, row : number)
    {
        this.currentDocument.insertionData.getRowData(row).isPrint = isPrint;
    }

    // 行並び替え
    private orderRow(isAscending : boolean)
    {
        var targetColumn = this.currentDocument.selectedInsertionColumn;
        this.currentDocument.insertionData.orderRowDataArray(isAscending, targetColumn);

        this.applyInsertionToFirstDesign();
        // デザイン更新
        this.updateDesign();
    }

    // 入力情報を最初のデザインに反映させる
    private applyInsertionToFirstDesign()
    {
        InsertionHelper.applyInsertionToFirstDesign(this.currentDocument);
    }

    private importDocument()
    {
        if(UserAgentHelper.isElectron())
        {
            // DL版はネイティブで保存する
            NativeHelper.sendNativeEvent("request_import_insertion_data", {});
            this.selectOpenStorageModalShown = false;
            return;
        }

        // ファイル読み込み
        var fileOpen = this.$refs.fileOpen;
        if(fileOpen != null && fileOpen instanceof FileOpen)
        {
            fileOpen.open();
            this.selectOpenStorageModalShown = false;
        }
    }

    // 面裏読み込み
    private changeSurface(isReverse : boolean)
    {
        // 面を返す前に、逆の面が存在しているかチェック
        var page = this.currentDocument.pageList[0];
        var isExistSurface = page.getSurface(isReverse).getDesign(0) != null;
        // 面が存在していない場合は新規作成
        if(!isExistSurface)
        {
            page.getSurface(isReverse).createNewDesign(0);
        }
        this.currentDocument.setSurface(isReverse);
        this.isReverse = isReverse;
        // デザイン更新
        this.updateDesign();
        this.$nextTick(() =>{
            // レイヤー位置情報更新
            this.updateLayerRects();
        });
    }

    // 差し込みIDからColumnDataを取得する
    private getColumnDataFromInsertionId(id)
    {
        for(var i = 0; i < this.currentDocument.insertionData.columnDataArray.length; ++i)
        {
            if(this.currentDocument.insertionData.columnDataArray[i].insertionId == id)
            {
                return this.currentDocument.insertionData.columnDataArray[i];
            }
        }
        return null;
    }

    // 会始行と終了行をリセット
    private resetRowRange()
    {
        this.currentDocument.insertionData.startRow = this.currentDocument.insertionData.isFirstRowAsColumnName ? 1 : 0;
        this.currentDocument.insertionData.endRow = this.currentDocument.insertionData.getRowDataCount() - 1;
    }

    private closeLicense(){
        this.isLicense = false;
        this.isTutorial = CookieHelper.getItem("insertionEditorTutorial") != true;
    }

     //-----configcolor-----//
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigThinColor(){
        return this.$store.getters.userConfigColors.buttonColorRgba;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }
    //-----configcolor-----//
}


